export default __webpack_public_path__ + "static/media/katanyilmaz5.fa307214.jpg";